import { constants, coreActions, coreStore, dataServices, polyfillPromise, Promise } from '@ambita/ambita-components-core';
import UserApi from 'infoland-components/api/UserApi';
import { fetchConfig } from './envConfig';

polyfillPromise();

const { core: coreConstants } = constants;

const loadAppCode = (): PromiseLike<any> => {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['../app'],
      (require: any): void => {
        try {
          const app = require('../app');
          resolve(app);
        } catch (err) {
          console.error('Error during app module evaluation:', err, typeof err);
          if (err && (err as any).stack) {
            console.error('Stack:', (err as any).stack);
          }
          reject(err);
        }
      },
      (error: any) => {
        reject(error);
      },
      'app'
    );
  });
};

const loadConfig = (): Promise<void> => {
  return fetchConfig().then((config) => {

    return new Promise((resolve) => {
      coreStore.on(coreConstants.TOKEN_NOT_FOUND_EVENT, UserApi.loginAnonymous);
      coreStore.once(coreConstants.USER_CHANGE_EVENT, resolve);

      const coreSettings = {
        environment: config.environment,
        language: 'nb',
        clientId: dataServices.config.CLIENT_ID_INFOLAND,
        mapProductsEnabled: true,
        linkProductsEnabled: true,
        ownershipReportProductEnabled: true,
        isNorgesEiendommerNewEnabled: config.isNorgesEiendommerNewEnabled,
        isAdvancedRegistrationFlowEnabled: config.isAdvancedRegistrationFlowEnabled,
        isAdvancedCreditCardRegistrationFlowEnabled: config.isAdvancedCreditCardRegistrationFlowEnabled
      };

      coreActions.changeSettings(coreSettings);
    });
  });
};

export const bootstrap = (): void => {
  loadConfig()
    .then(loadAppCode)
    .then(app => app.initialize())
    .catch((err: any) => {
      console.error('Bootstrap failed:', err, typeof err);
      if (err && err.stack) {
        console.error('Stack trace:', err.stack);
      }
    });
};
